import { create } from 'zustand'
import Swal from 'sweetalert2'
import { postOrderReview } from '../services/order'

export const useReviewOrderStore = create((set, get) => ({
  // modal
  open: false,
  order: null,

  // ratings
  chatQuality: 0,
  shippingSpeed: 0,
  reviewText: '',
  productRatings: [],

  // OPEN MODAL
  openReview(order) {
    if (!order) return
    const actions = order.action || order.actions
    const status = order.status
    const allowed = ['refund', 'success', 'success_with_cod_refund']
    if (!actions?.canReview || !allowed.includes(status)) return

    set({
      open: true,
      order,
      chatQuality: 0,
      shippingSpeed: 0,
      reviewText: '',
      productRatings: order.product.map(() => ({
        accuracy: 0,
        quality: 0,
        review: '',
      })),
    })
  },

  // CLOSE MODAL
  closeReview() {
    set({
      open: false,
      order: null,
      chatQuality: 0,
      shippingSpeed: 0,
      reviewText: '',
      productRatings: [],
    })
  },

  // UPDATE RATING
  setChatQuality(val) {
    set({ chatQuality: val })
  },

  setShippingSpeed(val) {
    set({ shippingSpeed: val })
  },

  setReviewText(val) {
    set({ reviewText: val })
  },

  updateProductRating: (index, field, value) =>
    set(state => {
      const updated = [...state.productRatings]
      updated[index] = { ...updated[index], [field]: value }
      return { productRatings: updated }
    }),

  // VALIDATION
  isValid() {
    const { chatQuality, shippingSpeed, productRatings } = get()
    return (
      chatQuality > 0 &&
      shippingSpeed > 0 &&
      productRatings.every(p => p.accuracy > 0 && p.quality > 0)
    )
  },

  // SUBMIT REVIEW
  async submit(token) {
    const { order, chatQuality, shippingSpeed, reviewText, productRatings } =
      get()

    if (!order) return
    if (!token) {
      Swal.fire('Gagal', 'Token tidak tersedia, silakan login ulang', 'error')
      return
    }

    if (!get().isValid()) return

    const payload = {
      orderId: order.no || order.orderId,
      chatQuality,
      shippingSpeed,
      review: reviewText || '',
      products: productRatings.map((p, index) => ({
        orderItemId: order.product[index].orderItemId,
        productAccuracy: p.accuracy,
        productQuality: p.quality,
        review: p.review || '',
      })),
    }

    try {
      Swal.fire({
        title: 'Mengirim ulasan...',
        didOpen: () => Swal.showLoading(),
        allowOutsideClick: false,
      })

      await postOrderReview({ token, data: payload })

      Swal.close()
      Swal.fire('Sukses!', 'Ulasanmu sudah terkirim 🎉', 'success')

      set({ open: false })
      window.location.reload()
    } catch (err) {
      Swal.close()
      Swal.fire('Gagal', 'Ulasan gagal dikirim', 'error')
    }
  },
}))
